import { FIAT_CURRENCY_DETAILS } from '@frontend/common/constants/currency';
import { SwapVenue } from '@frontend/shared/routefinder/venues';
import { getChain, getLatestRouter } from '@yodlpay/tokenlists';
import { useEffect, useState } from 'react';
import { Address, Chain } from 'viem';

export const PRECISION = 10n ** 18n;

export const getRouterAddress = (chainId?: number): Address | undefined => {
  if (!chainId) return undefined;
  const router = getLatestRouter(chainId);
  return router?.address;
};

// Lookup dexes configured in yodl-config and turn them into SwapVenues
export const swapVenuesOfChain = (chain: Chain) => {
  return getChain(chain.id).dexes as SwapVenue[];
};

export const useInvoiceCurrencies = () => {
  return Object.keys(FIAT_CURRENCY_DETAILS);
};

export function useDebounce<T>(value: T, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const [timestamp, setTimestamp] = useState(Date.now());

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      setTimestamp(Date.now());
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return { debouncedValue, timestamp };
}
